import { axiosV2 } from 'interceptors/axios';
import { Dispatch } from 'redux';
import { dispatchError } from 'utils/dispatchError';

import { decryptResponse } from 'utils/token';

type GetOperationDataForSEPAProps = {
  operationId: string;
  paymentConcept: string;
};

export const getOperationDataForSEPA =
  ({ operationId, paymentConcept }: GetOperationDataForSEPAProps) =>
  async (dispatch: Dispatch) => {
    const query = { params: { operationId, paymentConcept } };
    try {
      const { data } = await axiosV2.get(`/operations/data-for-sepa`, query);

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };
